import React, { useContext } from 'react';
import SelectCustom from 'components/object/formElement/SelectCustom';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextFieldCustom from 'components/object/formElement/TextFieldCustom';
import { ContextTrainingSearch } from 'context/ContextTrainingSearch';

const TrainingSearchBlock = () => {

  //context
  const {
    trainingSearch, setTrainingSearch
  } = useContext(ContextTrainingSearch);

  function createRegionHandler(data) {
    return { id: data.id, title: data.name, alias: data.name, labelValue: data.name };
  }

  function createInstructorHandler(data) {
    var label = data.firstname + " " + data.lastname;
    label += data.company ? " (" + data.company + ")" : '';
    return { 
      id: data.id, 
      title: label , 
      alias: label, 
      labelValue: label
    };
  }

  const changeRegionHandler = (regionId, alias, label, item) => {
    setTrainingSearch({ ...trainingSearch, id_region: regionId });
  }

  const changeSameInstructorHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, same_instructor: event.target.checked });
  }

  const changeInstructorAlreadyKnownHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, instructor_already_known: event.target.checked });
  }

  const changeInstructorHandler = (instructorId, alias, label, item) => {
    setTrainingSearch({ ...trainingSearch, id_instructor: instructorId });
  }

  const changeSearchFullFranceHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_full_france: event.target.checked });
  }

  const changeSearchPrometeaHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_prometea: event.target.checked });
  }

  const changeSearchSousTraitantHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_subcontractor: event.target.checked });
    
  }

  const changeSearchSecafiHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_secafi: event.target.checked });
  }

  const changeSearchAtlantesHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_atlantes: event.target.checked });
  }

  const changeSearchSecafiExpertiseHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, search_secafi_expertise: event.target.checked });
  }

  const changeInternalNoteHandler = (event) => {
    setTrainingSearch({ ...trainingSearch, internal_note: event.target.value });
  }

  return (
    <div className="trainingSearch-block">
      <div className="details-block training-search-details-block">
        <div className="details-sub-block">
          <div className="search-block-input-row">
            <SelectCustom
              title="Régions"
              api="instructor/regions/list"
              apiParam=""
              apiParamValue=""
              dataValue={trainingSearch?.id_region ?? 0}
              setDataValue={changeRegionHandler}
              defaultAlias=""
              creator={createRegionHandler}
              nosort={true}
            />
          </div>
          <div className="search-block-input-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.same_instructor ? true : false}
                  onChange={changeSameInstructorHandler}
                  name="same_instructor"
                />
              }
              label="Même formateur sur toute la session"
            />
          </div>
          <div className="search-block-input-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.instructor_already_known ? true : false}
                  onChange={changeInstructorAlreadyKnownHandler}
                  name="instructor_already_known_by_client"
                />
              }
              label="Formateur déjà intervenu chez le client"
            />
            <div className="instructor-select">
              <SelectCustom
                title="Formateurs"
                api="instructor/list"
                apiParam=""
                apiParamValue=""
                dataValue={trainingSearch?.id_instructor ?? 0}
                setDataValue={changeInstructorHandler}
                defaultAlias=""
                creator={createInstructorHandler}
              />
            </div>
          </div>
        </div>
        <div className="details-sub-block">
          <div className="search-block-input-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_full_france ? true : false}
                  onChange={changeSearchFullFranceHandler}
                  name="search_full_france"
                />
              }
              label="Rechercher dans toute la France"
            />
          </div>
          <div className="search-block-input-half-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_prometea ? true : false}
                  onChange={changeSearchPrometeaHandler}
                  name="prometea"
                />
              }
              label="Prometea"
            />
          </div>
          <div className="search-block-input-half-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_subcontractor ? true : false}
                  onChange={changeSearchSousTraitantHandler}
                  name="sous_traitant"
                />
              }
              label="Sous-traitant"
            />
          </div>
          <div className="search-block-input-half-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_secafi ? true : false}
                  onChange={changeSearchSecafiHandler}
                  name="secafi"
                />
              }
              label="Secafi"
            />
          </div>
          <div className="search-block-input-half-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_atlantes ? true : false}
                  onChange={changeSearchAtlantesHandler}
                  name="atlantes"
                />
              }
              label="Atlantes"
            />
          </div>
          <div className="search-block-input-half-row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={trainingSearch?.search_secafi_expertise ? true : false}
                  onChange={changeSearchSecafiExpertiseHandler}
                  name="secafi_expertises"
                />
              }
              label="Secafi Expertise"
            />
          </div>
        </div>
        <div className="details-sub-block">
          <div className="search-block-input-row internal-note-div">
            <TextFieldCustom
              label="Note Interne"
              multiline
              value={trainingSearch?.internal_note}
              onBlur={changeInternalNoteHandler}
              rows={3}
              fullWidth
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrainingSearchBlock;